import { ComponentProps, FC, ReactNode } from 'react'
import { styled } from '../../../../lib/stitches'
import { ChevronDown, StemIcon } from '../../../core/icons'
import { Loop, Soundwave } from '../../../core/icons/responsive-icons'
import {
  CLIPS_FILTER,
  DEFAULT_TYPE_FILTERS,
  MIDI_FILTER,
  ONE_SHOT_FILTER,
  TypeAndSubTypeFilter
} from '../hooks/useSounds'
import * as Dropdown from './Dropdown'

interface FilterType {
  icon: ReactNode
  value: TypeAndSubTypeFilter
  label: string
}

const segmentTrackFilter = (filter) => {
  const label = filter === 'stem' ? 'loop' : 'one shot'
  window.analytics.track('Button Clicked', {
    button: 'type',
    filter: label
  })
}

const LoopIcon = styled(Loop, {
  width: '16px',
  height: '16px',
  marginRight: '8px',
  flexShrink: 0
})

const SampleIcon = styled(Soundwave, {
  width: '16px',
  height: '16px',
  marginRight: '8px',
  flexShrink: 0
})

const MidiIcon = styled(StemIcon, {
  width: '16px',
  height: '16px',
  marginRight: '8px',
  flexShrink: 0
})

export const FILTER_TYPES: FilterType[] = [
  { value: CLIPS_FILTER, label: 'Clips', icon: <LoopIcon /> },
  {
    value: MIDI_FILTER,
    label: 'MIDI',
    icon: <MidiIcon />
  },
  {
    value: ONE_SHOT_FILTER,
    label: 'One-Shots',
    icon: <SampleIcon />
  }
]

type TypeDropdownProps = {
  filters: TypeAndSubTypeFilter[]
  defaultFilter?: TypeAndSubTypeFilter[]
  onSelect?: (filters: TypeAndSubTypeFilter) => void
} & Omit<ComponentProps<typeof Dropdown.Trigger>, 'onSelect'>

const TypeDropdown: FC<TypeDropdownProps> = ({
  filters,
  onSelect,
  defaultFilter = DEFAULT_TYPE_FILTERS,
  ...props
}) => {
  const handleSelect = (filter: TypeAndSubTypeFilter) => (evt) => {
    evt.preventDefault()
    onSelect(filter)
    segmentTrackFilter(filter)
  }
  const isSelected = (filter: TypeAndSubTypeFilter) => filters.includes(filter)
  return (
    <Dropdown.Root dir="ltr">
      <Dropdown.Trigger active={filters !== defaultFilter} {...props}>
        Type
        <ChevronDown />
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content side={'bottom'} align={'start'} sideOffset={4}>
          {FILTER_TYPES.map((filterType) => (
            <Dropdown.CheckboxItem
              key={filterType.label}
              css={{ width: '150px', justifyContent: 'start', alignItems: 'center' }}
              onSelect={handleSelect(filterType.value)}
              checked={isSelected(filterType.value)}
            >
              {filterType.icon}
              {filterType.label}
            </Dropdown.CheckboxItem>
          ))}
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  )
}

export default TypeDropdown
